import React from 'react';

// GLOBAL FUNCTIONS
import { formatDateTime } from 'functions';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// MAIN COMPONENT
const RecordLog = () => {
  const { record = {} } = useRecordContext() || {};

  // RENDER
  return !record.date_created && !record.date_updated && !record.updated_on && !record.created_on ? null : (
    <>
      <Card.Divider />
      <Form.PlainText
        label="Created On"
        value={
          record.created_on
            ? record.created_on
            : record.created_by
            ? `${formatDateTime(record.date_created)} by ${record.created_by}`
            : formatDateTime(record.date_created)
        }
      />
      <Form.PlainText
        label="Updated On"
        value={
          record.updated_on
            ? record.updated_on
            : record.updated_by
            ? `${formatDateTime(record.date_updated)} by ${record.updated_by}`
            : formatDateTime(record.date_updated)
        }
      />
    </>
  );
};

// EXPORT
export default RecordLog;
